import BCXRenderer from '@/utils/markdown/BCXRenderer';
import BCXRendererNoLinks from '@/utils/markdown/BCXRendererNoLinks';
import BCXRendererRestricted from '@/utils/markdown/BCXRendererRestricted';
import BCXRendererRestrictedNoLinks from '@/utils/markdown/BCXRendererRestrictedNoLinks';
import { emojis } from '@/utils/markdown/emojis';
import { ViewerOptions } from '@toast-ui/editor';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import BCXHTMLSanitizer from '../BCXHTMLSanitizer';

const bcxRenderer = BCXRenderer;
const bcxRendererNoLinks = BCXRendererNoLinks;
const bcxRendererRestricted = BCXRendererRestricted;
const bcxRendererRestrictedNoLinks = BCXRendererRestrictedNoLinks;
let renderMode = '';

export const setMode = (el: HTMLElement, mode: string): ViewerOptions => {
  switch (mode) {
    case 'restricted':
      return {
        el,
        customHTMLRenderer: bcxRendererRestricted,
        customHTMLSanitizer: BCXHTMLSanitizer.beforeRenderMarkdown,
        extendedAutolinks: true,
        usageStatistics: false,
      };
    case 'nolinks':
    case 'no-links':
      return {
        el,
        customHTMLRenderer: bcxRendererNoLinks,
        usageStatistics: false,
      };
    case 'restricted-no-links':
      return {
        el,
        customHTMLRenderer: bcxRendererRestrictedNoLinks,
        customHTMLSanitizer: BCXHTMLSanitizer.beforeRenderMarkdownNoLinks,
        extendedAutolinks: true,
        usageStatistics: false,
      };
    case 'public-blog':
      return {
        el,
        customHTMLRenderer: bcxRenderer,
        extendedAutolinks: true,
        usageStatistics: false,
        customHTMLSanitizer: BCXHTMLSanitizer.beforeRenderPublicBlogMarkdown,
      };
    case 'normal':
    default:
      return {
        el,
        customHTMLRenderer: bcxRenderer,
        extendedAutolinks: true,
        usageStatistics: false,
        customHTMLSanitizer: BCXHTMLSanitizer.beforeRenderMarkdown,
      };
  }
};

const markdown = (el: HTMLElement, mode = 'normal') => {
  if (renderMode !== mode) {
    renderMode = mode;
  }
  const viewer = new Viewer({
    ...setMode(el, mode),
  });
  return viewer;
};

export {
  markdown, emojis
};
